import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link} from "react-router-dom"
import './return-list.css'
import Slider from "react-slick";
import {userList} from '../../redux/chatuser.redux.js'
import { withRouter } from 'react-router-dom'
import {authenticationFn} from '../../redux/chatuser.redux.js'
import {getElementPosition} from '../../util.js'
import GiftAlert from '../../component/gift-alert/gift-alert.js'
import {getGiftSuccessCallBack} from  '../../redux/chatuser.redux.js'
import ToastBar from '../../component/toast/toast.js'
@withRouter
@connect(
  state=>state.chatuser,
  {userList,authenticationFn,getGiftSuccessCallBack}
)

class ReturnListPC89 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            GetPacks:'',
            getCates:'',
            zoneNum:0,
            navNum:0,
            showSelectWelfare:false,
            visible:false,
            showGetSuccess:false,
            iTop:'',		     
            giftData:'',
            key:1,
            inum:0,
            packId:'',
            showWrongAlert:false
        }
        this.game_id = this.props.match.params.id;
        this.handleLogin = this.handleLogin.bind(this)
    	this.showAlert = this.showAlert.bind(this)
    	this.showWrongAlert = this.showWrongAlert.bind(this)
    	this.ToastBarClose = this.ToastBarClose.bind(this)
    	this.onOff = true
        this.myAccountData=''
        
    	this.ReturnListCon89 = [{
			con1:'力量+30、敏捷+30、智力+30、体力+30，双攻+1%',
			con2:'最高生命值+1%'
		},
		{
			con1:'力量+50、敏捷+50、智力+50、体力+50，双攻+2%',
			con2:'最终伤害+50，最高生命值+2%'
		},{
			con1:'力量+100、敏捷+100、智力+100、体力+100',
			con2:'双攻+3%，最终伤害+100，最高生命值+3%'
		}
		]
    }
    componentDidMount(){
		document.title = '心享俱乐部—龙之谷回归特权'
  		if(this.props.inum==='1'){
  			this.handleGetCates('1')
  		}
  		if(this.props.inum==='2'){
  			this.handleGetCates('4')
  		}

    }
    componentWillReceiveProps(nextProps){
		
		if(this.props.getGiftSuccessData!==nextProps.getGiftSuccessData){
			if(nextProps.getGiftSuccessData==='1'){
				
		 		this.state.getCates[this.state.navNum]&&this.handleGetPacks(this.state.getCates[this.state.navNum].id)
		 		this.setState({
		 			myCateNum:0
		 		})
		 		
		 		//var oHref = window.location.href 
		 		//window.location.href = oHref
		 	}
		}
	
  		 if (this.props.accountData.account!== nextProps.accountData.account||nextProps.ikey){
  		 	
  		 	this.myAccountData = nextProps.accountData
  		 	
			if(nextProps.accountData.grade&&this.props.inum==='1'){
				
				const oGrade = nextProps.accountData.grade
				
				var num =''
				if(oGrade>=8){
				num = 2
				}
				if(oGrade>4&&oGrade<=7){
				num = 1
				}
				if(oGrade<=4){
				num = 0
				}
				this.setState({
					navNum:num					
				})
				if(nextProps.ikey){
					this.handleGetCates('1')
					return
				}

		  		this.state.getCates[num]&&this.handleGetPacks(this.state.getCates[num].id,nextProps.accountData)
		  				  		
	  		}
	  		if(!nextProps.accountData.grade){
	  			this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id,nextProps.accountData)
	  			this.setState({
					navNum:0
				})
	  		}
	  		if(this.props.inum==='2'){
	  			
				
	  			if(parseFloat(nextProps.iMoney)||parseFloat(nextProps.iMoney)==0){
	  			
	  			}else{
	  				this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id)
	  			}
	  		}
	  		
  	
  		 }

  	}
    handleGetCates(num){
  		
        axios.get('/fapi/recom/getCates?gameid='+this.game_id+'&type='+num)
          .then(res=>{
              if(res.data.return_code===0){
                  this.setState({
                      getCates:res.data.data
                  })
                  res.data.data.length&&this.handleGetPacks(res.data.data[this.state.navNum].id)
              }
          })

    }
    handleGetPacks(_id,accountData){
        var acData = ''
        if(this.myAccountData.t_account){  			
            acData = this.myAccountData.t_account

        }
        axios.get('/fapi/recom/getPacks?gameid='+this.game_id+'&cateid='+_id+'&account='+acData)
            .then(res=>{
                if(res.data.return_code===0){
  				
					var idata = res.data.data
					idata.ReturnListConStr = this.ReturnListCon89[this.state.navNum]
					this.setState({
						GetPacks:idata
						
					})
					this.props.getGiftSuccessCallBack('0')
  				}            
            })
    } 
	showWrongAlert(e){
		this.setState({
	  		showWrongAlert:true
	  	})
	}
    getGiftBtnFn(){
		
        if(this.props.userlist.code===-1){
            var str = '立即领取'
            var icls = 'btn active'
            var callBack = this.handleLogin
            
            if(this.props.inum==2&&this.state.navNum===0){
                str = '1元购买'
            }
            if(this.props.authentication==1||this.props.authentication==''){
              
              return <button className="btn active" onClick={()=>this.handleLogin()}>{str}</button>
            }
            if(this.props.authentication==3){
              
              if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 1){
                  
                    str = '立即领取'
                    
                    if(this.props.inum==2&&this.state.navNum===0){
                        
                     str = '1元购买'
                    }
                }
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 0){  				
                     str = '待解锁'
                     icls = 'btn unactive'
                     callBack = function () { }
                }
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 2){  				
                     str = '已领取'
                      icls = 'btn unactive'
                      callBack = function () { }
                }
                return <button className={icls} onClick={()=>callBack()}>{str}</button>
            }
            if(this.props.authentication==2){
                return <button className="btn unactive" >待解锁</button>
            }
        }else{
            var str = ''
            var icls = 'btn active'
            var callBack = this.showAlert
            if(this.props.authentication==3){
            
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 1){
                  
                    str = '立即领取'
                    
                    if(this.props.inum==2&&this.state.navNum===0){
                        
                     str = '1元购买'
                    }
                    if(this.state.GetPacks[0].alert){
                        callBack=this.showWrongAlert
                    }
                }
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 0){  				
                     str = '待解锁'
                     icls = 'btn unactive'
                     callBack = function () { }
                }
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 2){  				
                     str = '已领取'
                      icls = 'btn unactive'
                     callBack = function () { }
                }
                return <button className={icls} onClick={(e)=>callBack(e)}>{str}</button>
            }
            if(this.props.authentication==2){
                
                return <button className="btn unactive" >待解锁</button>
            }
        }
        
    }
    
  	showAlert(e){
        var idata = this.state.GetPacks[this.state.zoneNum].good_id
        this.setState({
            showSelectWelfare:true,
            visible:false,
            showGetSuccess:false,
            iTop:getElementPosition(e.target).y+'px',
            giftData:{id:idata},
            key:this.state.key+1,
            packId:this.state.GetPacks[this.state.zoneNum].id
        })
    }
    handleNav(i,_id){
		this.setState({
			navNum:i
		})
		this.handleGetPacks(_id)
  	}
    handleLogin(){		
		const pathname = this.props.location.pathname
		axios.get('/fapi/getLoginURL?redirect_url='+encodeURIComponent(encodeURIComponent(window.location.href)))
	      .then(res=>{
	       	if(res.data.return_code==0){
	       		window.location.href = res.data.redirect_url
	       	}		     
		 })
	}
    ToastBarClose(){
        this.setState({
            showWrongAlert:false,
                
        })
    }
    render() {
        return (
            <div>
                <div className="sdtq-content">
                    <div className={`sdtq-nav ${this.props.inum === '2' ? 'xiaohao-list' : ''}`}>
                        <ul>
                            {
                                this.state.getCates && this.state.getCates.map((item, i) => {
                                    return (
                                    <li key={i} className={i === this.state.navNum? 'active' : ''} onClick={() => this.handleNav(i, item.id)}>{item.name}
                                        {
                                            this.props.inum === '2' ? '' : <i></i>
                                        }
                                    </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    <div className="gifts-list-box">
                        {
                            this.props.inum === '1' ? 
                            <div>
                                {
                                    this.state.GetPacks && this.state.GetPacks[0].images.map((item, i) => (
                                        <div key={i} className="lzg-return-gift-list">
                                            <div className="lzg-gift-box">
                                                <p className="lzg-gift-title">专属回归称号</p>
                                                <p className="lzg-gift-name">{item.title}</p>
                                            </div>
                                            <div className="lzg-gift-box">
                                                <p className="lzg-gift-title">专属称号属性</p>
                                                <p className="lzg-gift-attr">{this.state.GetPacks.ReturnListConStr.con1}</p>
                                                <p className="lzg-gift-attr">{this.state.GetPacks.ReturnListConStr.con2}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            :
                            <div className="gifts-list">
                                <ul>
                                    {
                                        this.state.GetPacks && this.state.GetPacks[0].images.map((item, i) => (
                                            <li key={i}>
                                                <div className="">
                                                    <img src={item.imgurl} />
                                                </div>
                                                <p>{item.title}</p>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        }
                        
                        {this.getGiftBtnFn()}
                        
                        <GiftAlert 
                            key={this.state.key}
                            showSelectWelfare={this.state.showSelectWelfare}
                            visible={this.state.visible}
                            showGetSuccess={this.state.showGetSuccess}
                            iTop={this.state.iTop}
                            giftData={this.state.giftData||''}
                            packId={this.state.packId}
                        ></GiftAlert>
                        {
                            this.state.showWrongAlert&&<ToastBar 
                                visible={this.state.showWrongAlert}
                                title={'错误提示'}  
                                isOkShow ={false} 
                                itype={1}
                                ToastBarClose={this.ToastBarClose}
                            >
                                <div className="return-wrong-alert">抱歉，您在7月1日前回归登录龙之谷，不能领取回归称号</div>
                            </ToastBar>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default ReturnListPC89;


// WEBPACK FOOTER //
// ./src/component/return-list-pc/return-list-89.js